import api from '../api';
import * as types from '../constants';
import { getApiErrorMessage } from '../utils';
import localStorage from 'store';
import _indexOf from 'lodash/indexOf';
import { syncLocation } from './cart';

const fetchGeoIpStart = () => ({
  type: types.FETCH_GEOIP_BEGIN,
});

const fetchGeoIpFailure = payload => ({
  type: types.FETCH_GEOIP_FAILURE,
  payload,
});

const fetchGeoIpSuccess = payload => ({
  type: types.FETCH_GEOIP_SUCCESS,
  payload,
});

export const setLocationConfirmed = payload => (dispatch, getState) => {
  localStorage.set('location_confirmed', payload);
  let location = getState().user.location;

  dispatch({
    type: types.LOCATION_CONFIRM,
    payload,
  });
  dispatch(selectLocation(location));
};

export const loadFavoriteProducts = () => async (dispatch, getState) => {
  try {
    let uuid = getState().user.uuid;
    let { data } = await api.get(`/favorites/list`, {
      params: {
        uuid,
      },
    });
    dispatch({
      type: types.LOAD_FAVORITES,
      payload: data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const selectLocation = payload => async dispatch => {
  localStorage.set('user_location', payload);
  localStorage.set('location_confirmed', true);

  await dispatch({
    type: types.SET_LOCATION,
    payload,
  });

  await dispatch(syncLocation());
};

export const fetchGeoByIp = () => async (dispatch, getState) => {
  try {
    if (getState().user.location) return;
    dispatch(fetchGeoIpStart());
    let { data } = await api.get('/geo');
    localStorage.set('user_location', data);
    dispatch(fetchGeoIpSuccess(data));
  } catch (e) {
    dispatch(fetchGeoIpFailure(getApiErrorMessage(e)));
  }
};

export const addToFavorites = id => async (dispatch, getState) => {
  let userUuid = getState().user.uuid;
  let favorites = getState().user.favorites;
  let find = _indexOf(favorites, id) + 1;

  if (find) {
    favorites = favorites.filter(i => i !== id);
  } else {
    favorites.push(id);
    favorites = [...favorites];
  }

  await dispatch({
    type: types.ADD_TO_FAVORITES,
    payload: favorites,
  });

  await api.post(`/favorites/${id}`, {
    _method: 'PATCH',
    uuid: userUuid,
  });
};
